'use strict'

const rimraf = require('./rimraf')

function removeSync (dir) {
  return rimraf.sync(dir, {disableGlob: true})
}

function remove (dir, callback) {
  const options = {disableGlob: true}
  return callback ? rimraf(dir, options, callback) : rimraf(dir, options, function () {})
}

module.exports = {
  remove,
  removeSync
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-promise/~/fs-extra/lib/remove/index.js
// module id = 253
// module chunks = 0 1 2